<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 3C2 2.44772 2.44772 2 3 2H5C5.47668 2 5.8871 2.33646 5.98058 2.80388L6.2198 4H21C21.3466 4 21.6684 4.17945 21.8507 4.47427C22.0329 4.76909 22.0494 5.13723 21.8944 5.44721L17.8944 13.4472C17.725 13.786 17.3788 14 17 14H7.41421L5.41421 16H17C17.7957 16 18.5587 16.3161 19.1213 16.8787C19.6839 17.4413 20 18.2043 20 19C20 19.7957 19.6839 20.5587 19.1213 21.1213C18.5587 21.6839 17.7957 22 17 22C16.2043 22 15.4413 21.6839 14.8787 21.1213C14.3161 20.5587 14 19.7957 14 19C14 18.6561 14.0591 18.3182 14.1716 18H9.82843C9.94094 18.3182 10 18.6561 10 19C10 19.7957 9.68393 20.5587 9.12132 21.1213C8.55871 21.6839 7.79565 22 7 22C6.20435 22 5.44129 21.6839 4.87868 21.1213C4.31607 20.5587 4 19.7957 4 19C4 18.5359 4.10754 18.0829 4.3088 17.6743C3.32906 17.0242 3.04025 15.5455 3.99989 14.5859L5.91446 12.6713L4.1802 4H3C2.44772 4 2 3.55228 2 3ZM7.8198 12H16.382L19.382 6H6.6198L7.8198 12ZM7 18C6.73478 18 6.48043 18.1054 6.29289 18.2929C6.10536 18.4804 6 18.7348 6 19C6 19.2652 6.10536 19.5196 6.29289 19.7071C6.48043 19.8946 6.73478 20 7 20C7.26522 20 7.51957 19.8946 7.70711 19.7071C7.89464 19.5196 8 19.2652 8 19C8 18.7348 7.89464 18.4804 7.70711 18.2929C7.51957 18.1054 7.26522 18 7 18ZM17 18C16.7348 18 16.4804 18.1054 16.2929 18.2929C16.1054 18.4804 16 18.7348 16 19C16 19.2652 16.1054 19.5196 16.2929 19.7071C16.4804 19.8946 16.7348 20 17 20C17.2652 20 17.5196 19.8946 17.7071 19.7071C17.8946 19.5196 18 19.2652 18 19C18 18.7348 17.8946 18.4804 17.7071 18.2929C17.5196 18.1054 17.2652 18 17 18Z"
    />
  </svg>

</template>

<script lang="ts">
export default {
  name: "IconShoppingCart",
  props: ["height", "width"],
}
</script>
